import { forwardRef, Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromRoot from 'app/core/store';
import { from, Observable, of, switchMap, tap } from 'rxjs';
import { ConfirmDialogService } from '../../shared/confirm-dialog/confirm-dialog.service';
import { LanguageDataChangedAction } from '../store/admin/i18n/i18n.actions';

/**
 * Guard to synchronously clear orders filter & result
 */
@Injectable({ providedIn: 'root' })
export class PreventUnsavedI18nDataGuard implements CanDeactivate<any> {
  private store: Store<fromRoot.RootState>;

  constructor(@Inject(forwardRef(() => Store)) store, private confirmDialogService: ConfirmDialogService) {
    this.store = store;
  }

  canDeactivate(
    component: any,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean> {
    return this.store.select(state => state.i18n.dataChanged).pipe(
      switchMap(dataChanged => {
          if (dataChanged) {
            return from(this.confirmDialogService.askConfirmation({
              message: `You didn't save your changes!  Do you want to continue?`
            })).pipe(tap(discardChanges => {
              if (discardChanges) {
                this.store.dispatch(new LanguageDataChangedAction(false));
              }
            }));
          }
          return of(true);
        }
      ),
    )
  }
}
